
const getElementsToHide = () => {
    return [
        document.querySelector('.csh-aem-base-header__nav-list'),
        document.querySelector('.csh-aem-base-header__button--search-wrap'),
        document.querySelector('.csh-aem-base-header__button--desktop')
    ];
}

const removeBackdrop = (mutationsList) => {
    mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
                if (node.classList && node.classList.contains('modal-backdrop')) {
                    node.remove();
                }
            });
        }
    });
}

const toggleElements = (elements, action) => {
    elements.forEach(element => {
        if (element) {
            const isHidden = action === 'hide';
            element.classList.toggle('hidden-element', isHidden);
        } 
    });
}

export { getElementsToHide, removeBackdrop, toggleElements };

